import { CALL_API } from 'redux-api-middleware';

/**
 * HTTP Methods
 */
export const POST = 'POST';
export const PATCH = 'PATCH';
export const GET = 'GET';
export const PUT = 'PUT';

/**
 * Action constants
 */
export const REQUEST_LOGIN_STORE_MANAGER = 'REQUEST_LOGIN_STORE_MANAGER';
export const SUCCESS_LOGIN_STORE_MANAGER = 'SUCCESS_LOGIN_STORE_MANAGER';
export const FAILED_LOGIN_STORE_MANAGER = 'FAILED_LOGIN_STORE_MANAGER';

export const REQUEST_IS_LOGGED_IN_STORE_MANAGER = 'REQUEST_IS_LOGGED_IN_STORE_MANAGER';
export const SUCCESS_IS_LOGGED_IN_STORE_MANAGER = 'SUCCESS_IS_LOGGED_IN_STORE_MANAGER';
export const FAILED_IS_LOGGED_IN_STORE_MANAGER = 'FAILED_IS_LOGGED_IN_STORE_MANAGER';

export const REQUEST_GET_PLP_PRODUCTS = 'REQUEST_GET_PLP_PRODUCTS';
export const SUCCESS_GET_PLP_PRODUCTS = 'SUCCESS_GET_PLP_PRODUCTS';
export const FAILED_GET_PLP_PRODUCTS = 'FAILED_GET_PLP_PRODUCTS';

export const REQUEST_GET_PLP_LOAD_MORE_PRODUCTS = 'REQUEST_GET_PLP_LOAD_MORE_PRODUCTS';
export const SUCCESS_GET_PLP_LOAD_MORE_PRODUCTS = 'SUCCESS_GET_PLP_LOAD_MORE_PRODUCTS';
export const FAILED_GET_PLP_LOAD_MORE_PRODUCTS = 'FAILED_GET_PLP_LOAD_MORE_PRODUCTS';

export const REQUEST_GET_PDP_PRODUCT = 'REQUEST_GET_PDP_PRODUCT';
export const SUCCESS_GET_PDP_PRODUCT = 'SUCCESS_GET_PDP_PRODUCT';
export const FAILED_GET_PDP_PRODUCT = 'FAILED_GET_PDP_PRODUCT';

export const REQUEST_PRODUCT_BY_SKU = 'REQUEST_PRODUCT_BY_SKU';
export const SUCCESS_PRODUCT_BY_SKU = 'SUCCESS_PRODUCT_BY_SKU';
export const FAILURE_PRODUCT_BY_SKU = 'FAILURE_PRODUCT_BY_SKU';

export const REQUEST_GET_PRODUCTS_PURCHASED = 'REQUEST_GET_PRODUCTS_PURCHASED';
export const SUCCESS_GET_PRODUCTS_PURCHASED = 'SUCCESS_GET_PRODUCTS_PURCHASED';
export const FAILED_GET_PRODUCTS_PURCHASED = 'FAILED_GET_PRODUCTS_PURCHASED';

export const REQUEST_GET_PRODUCTS_TRIALED = 'REQUEST_GET_PRODUCTS_TRIALED';
export const SUCCESS_GET_PRODUCTS_TRIALED = 'SUCCESS_GET_PRODUCTS_TRIALED';
export const FAILED_GET_PRODUCTS_TRIALED = 'FAILED_GET_PRODUCTS_TRIALED';

export const REQUEST_POST_PRODUCTS_TRIALED = 'REQUEST_POST_PRODUCTS_TRIALED';
export const SUCCESS_POST_PRODUCTS_TRIALED = 'SUCCESS_POST_PRODUCTS_TRIALED';
export const FAILED_POST_PRODUCTS_TRIALED = 'FAILED_POST_PRODUCTS_TRIALED';

export const REQUEST_POST_PRODUCTS_CART = 'REQUEST_POST_PRODUCTS_CART';
export const SUCCESS_POST_PRODUCTS_CART = 'SUCCESS_POST_PRODUCTS_CART';
export const FAILED_POST_PRODUCTS_CART = 'FAILED_POST_PRODUCTS_CART';

export const REQUEST_GET_PRODUCTS_CART = 'REQUEST_GET_PRODUCTS_CART';
export const SUCCESS_GET_PRODUCTS_CART = 'SUCCESS_GET_PRODUCTS_CART';
export const FAILED_GET_PRODUCTS_CART = 'FAILED_GET_PRODUCTS_CART';

export const REQUEST_PLACE_ORDER = 'REQUEST_PLACE_ORDER';
export const SUCCESS_PLACE_ORDER = 'SUCCESS_PLACE_ORDER';
export const FAILED_PLACE_ORDER = 'FAILED_PLACE_ORDER';

export const REQUEST_SEARCH_CUSTOMER = 'REQUEST_SEARCH_CUSTOMER';
export const SUCCESS_SEARCH_CUSTOMER = 'SUCCESS_SEARCH_CUSTOMER';
export const FAILED_SEARCH_CUSTOMER = 'FAILED_SEARCH_CUSTOMER';

export const REQUEST_GET_CUSTOMER_INFO = 'REQUEST_GET_CUSTOMER_INFO';
export const SUCCESS_GET_CUSTOMER_INFO = 'SUCCESS_GET_CUSTOMER_INFO';
export const FAILED_GET_CUSTOMER_INFO = 'FAILED_GET_CUSTOMER_INFO';

export const REQUEST_GET_CUSTOMER_ADVANCED_INFO = 'REQUEST_GET_CUSTOMER_ADVANCED_INFO';
export const SUCCESS_GET_CUSTOMER_ADVANCED_INFO = 'SUCCESS_GET_CUSTOMER_ADVANCED_INFO';
export const FAILED_GET_CUSTOMER_ADVANCED_INFO = 'FAILED_GET_CUSTOMER_ADVANCED_INFO';

export const REQUEST_UPDATE_CUSTOMER = 'REQUEST_UPDATE_CUSTOMER';
export const SUCCESS_UPDATE_CUSTOMER = 'SUCCESS_UPDATE_CUSTOMER';
export const FAILED_UPDATE_CUSTOMER = 'FAILED_UPDATE_CUSTOMER';

export const SET_SELECTED_CUSTOMER = 'SET_SELECTED_CUSTOMER';


export const REQUEST_GET_PRODUCTS_SPECS = 'REQUEST_GET_PRODUCTS_SPECS';
export const SUCCESS_GET_PRODUCTS_SPECS = 'SUCCESS_GET_PRODUCTS_SPECS';
export const FAILED_GET_PRODUCTS_SPECS = 'FAILED_GET_PRODUCTS_SPECS';

export const REQUEST_GET_CHECKLIST = 'REQUEST_GET_CHECKLIST';
export const SUCCESS_GET_CHECKLIST = 'SUCCESS_GET_CHECKLIST';
export const FAILED_GET_CHECKLIST = 'FAILED_GET_CHECKLIST';

export const REQUEST_ADD_CHECKLIST = 'REQUEST_ADD_CHECKLIST';
export const SUCCESS_ADD_CHECKLIST = 'SUCCESS_ADD_CHECKLIST';
export const FAILED_ADD_CHECKLIST = 'FAILED_ADD_CHECKLIST';

export const REQUEST_GET_ORDERS = 'REQUEST_GET_ORDERS';
export const SUCCESS_GET_ORDERS = 'SUCCESS_GET_ORDERS';
export const FAILED_GET_ORDERS = 'FAILED_GET_ORDERS';

export const REQUEST_GET_ORDER_BY_ORDERID = 'REQUEST_GET_ORDER_BY_ORDERID';
export const SUCCESS_GET_ORDER_BY_ORDERID = 'SUCCESS_GET_ORDER_BY_ORDERID';
export const FAILED_GET_ORDER_BY_ORDERID = 'FAILED_GET_ORDER_BY_ORDERID';

export const REQUEST_CREATE_CUSTOMER = 'REQUEST_CREATE_CUSTOMER';
export const SUCCESS_CREATE_CUSTOMER = 'SUCCESS_CREATE_CUSTOMER';
export const FAILED_CREATE_CUSTOMER = 'FAILED_CREATE_CUSTOMER';

export const SET_HAS_MORE = 'SET_HAS_MORE';
export const RESET_HAS_MORE = 'RESET_HAS_MORE';
export const UPDATE_OFFSET = 'UPDATE_OFFSET';
export const SET_SALE_STATE = 'SET_SALE_STATE';

export const REQUEST_LOADING_START = 'REQUEST_LOADING_START';
export const REQUEST_LOADING_DONE = 'REQUEST_LOADING_DONE';

export const ADD_CUSTOMER_TO_LOCAL = 'ADD_CUSTOMER_TO_LOCAL';
export const LOCAL_STORE_CUSTOMERS_KEY = 'ps_local_store_customers';

export const REQUEST_ADD_PETTY_CASH = 'REQUEST_ADD_PETTY_CASH';
export const SUCCESS_ADD_PETTY_CASH = 'SUCCESS_ADD_PETTY_CASH';
export const FAILED_ADD_PETTY_CASH = 'FAILED_ADD_PETTY_CASH';

export const REQUEST_ADD_GLOBAL_COUNT = 'REQUEST_ADD_GLOBAL_COUNT';
export const SUCCESS_ADD_GLOBAL_COUNT = 'SUCCESS_ADD_GLOBAL_COUNT';
export const FAILED_ADD_GLOBAL_COUNT = 'FAILED_ADD_GLOBAL_COUNT';

export const REQUEST_ADD_FEEDBACK = 'REQUEST_ADD_FEEDBACK';
export const SUCCESS_ADD_FEEDBACK = 'SUCCESS_ADD_FEEDBACK';
export const FAILED_ADD_FEEDBACK = 'FAILED_ADD_FEEDBACK';

export const SUCCESS_ATTENDANCE = 'SUCCESS_ATTENDANCE';

export const SUCCESS_PETTY_CASH = 'SUCCESS_PETTY_CASH';

export const REQUEST_CHECK_COUPON = 'REQUEST_CHECK_COUPON';
export const SUCCESS_CHECK_COUPON = 'SUCCESS_CHECK_COUPON';
export const FAILED_CHECK_COUPON = 'FAILED_CHECK_COUPON';

export const REQUEST_DISABLE_COUPON = 'REQUEST_DISABLE_COUPON';
export const SUCCESS_DISABLE_COUPON = 'SUCCESS_DISABLE_COUPON';
export const FAILED_DISABLE_COUPON = 'FAILED_DISABLE_COUPON';

export const REQUEST_ADD_LEAD = 'REQUEST_ADD_LEAD';
export const SUCCESS_ADD_LEAD = 'SUCCESS_ADD_LEAD';
export const FAILED_ADD_LEAD = 'FAILED_ADD_LEAD';

export const REQUEST_SEND_OTP = 'REQUEST_SEND_OTP';
export const SUCCESS_SEND_OTP = 'SUCCESS_SEND_OTP';
export const FAILED_SEND_OTP = 'FAILED_SEND_OTP';

export const REQUEST_VERIFY_OTP = 'REQUEST_VERIFY_OTP';
export const SUCCESS_VERIFY_OTP = 'SUCCESS_VERIFY_OTP';
export const FAILED_VERIFY_OTP = 'FAILED_VERIFY_OTP';

export const SET_SELECTED_LANGUAGE = 'SET_SELECTED_LANGUAGE'

export const REQUEST_SUBSCRIBER = 'REQUEST_SUBSCRIBER'
export const FAILED_SUBSCRIBER = 'FAILED_SUBSCRIBER'
export const SUCCESS_SUBSCRIBER = 'SUCCESS_SUBSCRIBER'

export const REQUEST_PARTNER_ENQUIRY_FORM = 'REQUEST_PARTNER_ENQUIRY_FORM'
export const FAILED_PARTNER_ENQUIRY_FORM = 'FAILED_PARTNER_ENQUIRY_FORM'
export const SUCCESS_PARTNER_ENQUIRY_FORM = 'SUCCESS_PARTNER_ENQUIRY_FORM'

export const REQUEST_PINCODE_DETAILS = 'REQUEST_PINCODE_DETAILS';
export const SUCCESS_PINCODE_DETAILS = 'SUCCESS_PINCODE_DETAILS';
export const FAILED_PINCODE_DETAILS= 'FAILED_PINCODE_DETAILS';

/**
 * Generic API redux middleware method
 * @param method
 * @param endpoint
 * @param request
 * @param success
 * @param failure
 * @param body
 * @param queryParams
 * @param credentials
 * @returns {{}}
 */
export const getApiMiddlewareJson =
(endpoint, method, request, success, failure, body, queryParams, credentials = true) => {
  const jsonObject = {
    method,
    endpoint,
    types: [request, success, failure],
    headers: { 'Content-Type': 'application/json' },
  };

  if (method === 'POST' || method === 'PATCH') { jsonObject.body = JSON.stringify(body); }

  if (queryParams) { jsonObject.endpoint = `${endpoint}?q=${queryParams}`; }

  if (credentials) { jsonObject.credentials = 'include'; }

  return {
    [CALL_API]: jsonObject,
  };
};



// WEBPACK FOOTER //
// ./src/actions/generic.js